// src/pages/Login.tsx
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../api";

export default function Login() {
  const [loginId, setLoginId] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleLogin = async () => {
    try {
      const res = await api.post(
        "/auth/login",
        { login_id: loginId, password },
        { withCredentials: true }
      );

      const tenant_id = res.data?.user?.tenant_id;
      if (!tenant_id) {
        alert("Tenant ID not found");
        return;
      }

      // redirect to callback with params
      navigate(
        `/callback?login_id=${encodeURIComponent(loginId)}&tenant_id=${tenant_id}`
      );
    } catch (err: any) {
      alert(err?.response?.data?.message || "Login failed");
    }
  };

  return (
    <div
      style={{
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        backgroundColor: "#f5f5f5",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        margin: 0,
      }}
    >
      <div
        style={{
          backgroundColor: "white",
          padding: "40px",
          borderRadius: "8px",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
          width: "100%",
          maxWidth: "400px",
          textAlign: "center",
        }}
      >
        <h1
          style={{
            color: "#333",
            marginBottom: "30px",
            fontWeight: 600,
          }}
        >
          SSO PROVIDER
        </h1>

        <div style={{ marginBottom: "20px", textAlign: "left" }}>
          <label
            style={{
              display: "block",
              marginBottom: "8px",
              color: "#555",
              fontWeight: 500,
            }}
          >
            Email Address
          </label>
          <input
            type="email"
            value={loginId}
            onChange={(e) => setLoginId(e.target.value)}
            style={{
              width: "100%",
              padding: "12px",
              border: "1px solid #ddd",
              borderRadius: "4px",
              fontSize: "16px",
              boxSizing: "border-box",
            }}
            placeholder="Enter your email"
          />
        </div>

        <div style={{ marginBottom: "20px", textAlign: "left" }}>
          <label
            style={{
              display: "block",
              marginBottom: "8px",
              color: "#555",
              fontWeight: 500,
            }}
          >
            Password
          </label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={{
              width: "100%",
              padding: "12px",
              border: "1px solid #ddd",
              borderRadius: "4px",
              fontSize: "16px",
              boxSizing: "border-box",
            }}
            placeholder="Enter your password"
          />
        </div>

        <button
          onClick={handleLogin}
          style={{
            backgroundColor: "#4285f4",
            color: "white",
            border: "none",
            padding: "12px",
            width: "100%",
            borderRadius: "4px",
            fontSize: "16px",
            fontWeight: 500,
            cursor: "pointer",
            marginTop: "10px",
            transition: "background-color 0.3s",
          }}
          onMouseOver={(e) =>
            (e.currentTarget.style.backgroundColor = "#3367d6")
          }
          onMouseOut={(e) =>
            (e.currentTarget.style.backgroundColor = "#4285f4")
          }
        >
          Log in
        </button>
      </div>
    </div>
  );
}
